import { render, staticRenderFns } from "./DetailProuct.vue?vue&type=template&id=c49dd2c0&scoped=true&"
import script from "./DetailProuct.vue?vue&type=script&lang=js&"
export * from "./DetailProuct.vue?vue&type=script&lang=js&"
import style0 from "./DetailProuct.vue?vue&type=style&index=0&id=c49dd2c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49dd2c0",
  null
  
)

export default component.exports